/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_DescriptionInputs */



/**
* | output |
* | --- |
* | "Serve this canvas on a domain you own, instead of a share link. You'll need access to the domain's DNS settings." |
*
* @param {Canvas_Domain_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_description = /** @type {((inputs?: Canvas_Domain_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Stellen Sie dieses Canvas unter einer eigenen Domain bereit, anstatt über einen Freigabelink. Sie benötigen Zugriff auf die DNS-Einstellungen der Domain.")
	return /** @type {LocalizedString} */ ("Serve this canvas on a domain you own, instead of a share link. You'll need access to the domain's DNS settings.")
});